// stores/navigation.js
import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    tempData: null
  }),
  actions: {
    setState(data) {
      this.tempData = data;
    },
    clearTempData() {
      this.$reset();
     this.tempData = null;
       localStorage.removeItem('navigation');
    },
  },
  persist: {
    key: 'navigation',
    storage: localStorage
  }
});
